import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../AbstractElements";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Earnings } from "../../../Constant";
import { ECOMMERCE_RADIAL_DATA } from "../../../Data/Dashboard";

const Earning = () => {
  return (
    <Col xl="3" md="5" sm="12" className="box-col-3 pre-order">
      <Card>
        <CommonCardHeader title={Earnings} className="card-no-border" />
        <CardBody className="pt-0">
          <div id="earning">
            <ReactApexChart options={ECOMMERCE_RADIAL_DATA} series={ECOMMERCE_RADIAL_DATA.series} type="radialBar" height={280} />
          </div>
          <div className="earning text-center">
            <P className="mb-0"><strong>$3563.98 </strong>(Total Expense)</P>
            <span>Earning</span>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Earning;
